<template>
  <div class="content">
    <div class="filter_box">
      <div class="row">
        <!-- 考生信息 -->
        <div class="item"  style="padding-left:20px">
          <div class="own_name">考生信息：</div>
          <el-input v-model="keyword" @change="keywordSearch" placeholder="可搜索姓名或手机号" ></el-input>
        </div>
        <!-- 工种 -->
        <div class="item">
          <div class="own_name">批次：</div>
          <el-select v-model="appraisalId" placeholder="请选择批次">
            <el-option
              v-for="(item,index) in batchList"
              :key="index"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <!-- 工种 -->
        <div class="item">
          <div class="own_name">工种：</div>
          <el-select v-model="occupation" placeholder="请选择工种">
            <el-option
              v-for="(item,index) in occupationList"
              :key="index"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </div>
        <!-- 等级 -->
        <div class="item">
          <div class="own_name">等级：</div>
          <el-select placeholder="请选择等级" v-model="level">
            <el-option
              v-for="(item,index) in levelList"
              :key="index"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <div class="own_name">证书状态：</div>
          <el-select placeholder="请选择证书状态" v-model="status">
            <el-option
              v-for="(item,index) in statusList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="exam_button_box">
      <el-button type="primary" @click="getGradeList()">查询</el-button>
      <el-button type="primary" :loading="requestLoadingObj.exportLoading" @click="getExport()">导出</el-button>
    </div>
    <div class="content_box">
      <table class="tablecontain">
        <thead>
          <tr class="tablehead">
            <th class="name">序号</th>
            <th >姓名</th>
            <th>手机号</th>
            <th>批次</th>
            <th>工种</th>
            <th>等级</th>
            <th>理论成绩</th>
            <th>实操成绩</th>
            <th>考试日期</th>
            <th class="test">证书状态</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tablebody" v-for="(item, index) in gradeList" :key="index">
            <td>{{ item.serial }}</td>
            <td>{{ item.examName }}</td>
            <td>{{ item.examPhone }}</td>
            <td>{{ item.appraisalBatchName }}</td>
            <td>{{ item.examSubiectName }}</td>
            <td>{{ item.examRank}}</td>
            <td>{{ item.theScore }}</td>
            <td>{{ item.opeScore }}</td>
            <td>{{ item.examTime }}</td>
            <td>{{ item.statusText }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="!gradeList.length" style="width:100%;margin-top:20px;text-align:center;color:grey">暂无数据</div>
      <div class="page_footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[12, 24, 48, 360]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listCount">
      </el-pagination>
    </div>
    </div>
  </div>
</template>

<script>
import {downloadBlob} from '@/utils/util.js'
export default {
  data() {
    return {
      gradeList: [],
      statusObj: {
        'pending': '待生成',
        'finish': '已生成',
        'unPass': '不合格'
      },
      batchList: [],
      statusList: [
        {'name': '全部状态', 'value': ''},
        {'name': '不合格', 'value': 'unPass'},
        {'name': '待生成', 'value': 'pending'},
        {'name': '已生成', 'value': 'finish'},
      ],
      occupationList: [],  
      appraisalId: '',
      occupation: '',
      levelList: [],
      level: '',
      subjectList: [],
      listCount: 0,
      subject: '',
      status: '',
      keyword: '',
      page: 1,
      limit: 12,
      requestLoadingObj:{
        exportLoading: false
      }
    }
  },
  computed: {
    levelFlag: function() {
      return this.levelList.length > 1
    },
    subjectFlag: function() {
      return this.subjectList.length > 1
    }
  },
  watch: {
    appraisalId: function() {
      let currentBatchList = this.batchList.filter(ele=> ele.id === this.appraisalId)
      this.occupationList = [{'name': currentBatchList[0].occupationName}]
      this.levelList = [{'name': currentBatchList[0].occupationLevel}]
      this.occupation = this.occupationList[0].name
      this.level = this.levelList[0].name
      this.getGradeList()
    },
    status: function() {
      this.getGradeList()
    }
  },
  created(){
    this.getBatchList()
  },
  methods: {
    getBatchList: function() { //查询现有批次信息
      this.$http.get('/examination/batch/list').then(res => {
        if(res.data.data){
          this.batchList = this.batchList.concat(res.data.data)
          this.appraisalId = this.batchList.find(element => element.occupationLevelCode === 'sk-003' ).id
        }
      })
    },
    getGradeList: function() {  //查询列表
      let params = {
        keyword: this.keyword, //关键字
        page: this.page,
        limit: this.limit,
        status: this.status,
        appraisalId: this.appraisalId //批次
      }
      this.$http.get('/registration/certificate/status', { params }).then(res => {
        let list = res.data.data.resultList || []
        this.listCount = res.data.data.totalCount
        if(res.data.success){
          list.forEach((element,index) => {
            element.serial = (this.page - 1) * this.limit + index + 1
            element.statusText = this.statusObj[element.certificateStatus]
          })
          this.gradeList = list
        }
      })
    },
    getExport: function() {
      this.requestLoadingObj.exportLoading = true
      let params = {
        appraisalId: this.appraisalId,
        subject: ''
      }
      this.$http.post('/examFile/export/score', params, {responseType: 'blob'}).then(res => {
        if(res.data){
          let filename = decodeURIComponent(res.headers.filename)
          downloadBlob(res.data, filename)
        }else{
          this.$message({
            message: res.data.msg,
            type: "error",
          })
        }
      }).finally(() => {
        this.requestLoadingObj.exportLoading = false
      })
    },
    handleSizeChange(val) {
      this.page = 1
      this.limit = val
      this.getGradeList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getGradeList()
    },
    keywordSearch: function() {
      this.page = 1
      this.getGradeList()
    }
  }
}
</script>

<style scoped lang="less">
*{
  box-sizing: border-box;
}
.content {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;
  padding-top: 30px;
  min-width: 1980px;
  height: 100vh;
  background-color: white;
}
.filter_box {
  width: 100%;
  padding: 20px;
  .row{
    width: 100%;
    justify-content: space-between;
    display: flex;
    .item{
      display: flex;
      padding: 15px 40px 15px 0px;
      align-items: center;
    }
  }
}
.content_box{
  padding: 0 @checkringht @checkringht @checkringht;
  background: @whitee;
  margin-top: -30px;
}
.own_name{
  color: @leftcolor;
  font-weight: 600;
  width: 200px;
  text-align: end;
}
.page_footer{
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  .van-pagination{
    margin: 0 20px;
  }
}

#top {
  text-align: center;
  height: @headerh;
  box-sizing: border-box;
  padding-top: @headerpt;
  background-color:@backgroundcolor;
  padding-bottom: @headerpb;
}

.rightcha {
  float: left;
}
.rightcha img {
  vertical-align: middle;
}
.flexcontain{
  display: flex;
  margin-top: @checkringht;
  // height: 80px;
  justify-content: center;
  align-items: center;
    
}
.own_input,.cat-choose{
  flex: 1;
  height: @minboxgao;
  line-height: @minboxgao;
}
.tablecontain{
  width: 100%;
  border-left: 1px solid @tableborder;
  border-top: 1px solid @tableborder;
  border-spacing: 0;
  margin-top: @minboxgao;
  .tablebody:nth-child(2n+2){
    background: @tablecolor;
  }
}
 .tablehead>th,.tablebody>td{
  border-right: 1px solid @tableborder;
  border-bottom: 1px solid @tableborder;
  text-align: center;
  padding: 0 20px;
  white-space: nowrap;
}
.tablebody>td {
  padding: 20px;
}
.tablebody>td>img{
  width: 30px;
  height: 15px;
  margin-left: 4px;
}
.tablehead{
  font-size: 24px;
}
.tablehead .sub{
  width: 95px;
  height: 50px;
}
.tablehead .test{
  width: 110px;
  height: 100px;
}
.tablehead .name {
  width: 96px;
}

.filter_box ::v-deep .el-input__inner{
  width: 300px;
}
.exam_button_box {
  display: flex;
  justify-content: flex-end;
  margin-right: 60px;
}
</style>
